/* Millimili 3.0 — assets/mm3-product.js (ürün sayfası davranışları; sections/main-product.liquid yükler)
 *
 * 1) Galeri kancası (window.mm3GalleryFilter): gallery.js filterSlides süzmeden sonra çağırır.
 *    - Galeride HİÇ video yok (D18, sahibin talimatı): her rengin videosu yalnız "In motion" bandında, tek bir tane.
 *    - Renk başına en çok N fotoğraf (gallery-section[data-mm3-max], D15), #all fotoğrafı da sayılır.
 * 2) "Select a size" durumu: beden seçilmemişken buton aria-disabled + "Select a size"; renk değişince Wonder'ın
 *    setUnavailable() çıktısı (fiyatı gizler, "Unavailable") geri alınır; tıklayınca beden seçicisine gider.
 * 3) Beden rehberi: beden satırındaki "Size guide" Pify Size Charts düğmesini açar (Pify düğmesi görsel olarak gizli).
 * 4) Mobil sabit çubuk: "$fiyat · Renk", renk görseli; beden seçiliyse doğrudan sepete ekler.
 * 5) Akordeon: aynı anda tek açık (Wonder data-accordion-set).
 * 6) Galeri sayfalama hapları: "Show image i of n" + aria-pressed (tasarım). Swiper a11y yalnız {{index}} doldurur
 *    ("Go to slide i", aria-current); etiketler Swiper her güncellediğinde (süzme, yeniden kurulum) yeniden yazılır.
 */
(() => {
  if (window.__mm3Product) return;
  window.__mm3Product = true;

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollOpts = (block = 'center') => ({ behavior: reduceMotion() ? 'auto' : 'smooth', block });

  /* ---------- 1) galeri kancası ---------- */
  const kindOf = (el) => el.dataset.mm3Kind || (el.querySelector('video') ? 'video' : 'image');

  // D18: galeri yalnız fotoğraf. Liquid videoyu hiç basmıyor; bu süzme, sunucudan yeniden çizilen ya da başka yoldan
  // gelen bir video slaytı renk değişiminde de galeriye sızmasın diye (ilk açılış ve varyant değişimi aynı kural).
  window.mm3GalleryFilter = (slides, options, gallery) => {
    if (!gallery || !gallery.hasAttribute('data-mm3-max')) return slides;
    gallery.setAttribute('data-mm3-ready', '');
    const max = Number(gallery.dataset.mm3Max || 0);
    let out = slides.filter((s) => kindOf(s) === 'image');
    if (max > 0) out = out.slice(0, max); // renk başına en çok N fotoğraf, DOM (kalite) sırasıyla
    const shown = out.length ? out : slides; // galeri hiç boş kalmasın (DOM'da video yok; pratikte hep fotoğraf)
    labelViews(shown);
    return shown;
  };

  // Alt metin: görünür fotoğraflara "…, view i of n" (tasarım; ekran okuyucu aynı metni 6 kez okumasın).
  // Liquid'deki ilk alt metin ("Ürün in Renk") data-mm3-base'de saklanır; süzme ham metni data-mm3-alt'tan okur.
  function labelViews(list) {
    const imgs = list.filter((s) => kindOf(s) === 'image').map((s) => s.querySelector('img')).filter(Boolean);
    const n = imgs.length;
    imgs.forEach((img, i) => {
      if (img.dataset.mm3Base == null) img.dataset.mm3Base = img.getAttribute('alt') || '';
      const base = img.dataset.mm3Base;
      img.setAttribute('alt', n > 1 && base ? `${base}, view ${i + 1} of ${n}` : base);
    });
  }

  const optionsOf = (vo) =>
    Array.from(vo.querySelectorAll('.wt-product__option')).map((fs) => {
      const r = Array.from(fs.querySelectorAll('input')).find((i) => i.checked);
      return r ? r.value : '';
    });

  // Beden seçilmemişken Wonder açılışta galeriyi süzmüyor (currentVariant yok): biz süzeriz.
  function initialGalleryFilter() {
    document.querySelectorAll('gallery-section[data-mm3-max]').forEach((g) => {
      if (g.hasAttribute('data-mm3-ready')) return;
      const sid = (g.id || '').replace('MediaGallery-', '');
      const vo = document.querySelector(`variant-options[data-section="${sid}"]`);
      const options = vo ? optionsOf(vo) : [];
      try {
        g.filterSlides(options, false, true);
      } catch (e) {
        g.setAttribute('data-mm3-ready', '');
      }
    });
  }

  /* ---------- 2) "Select a size" durumu ---------- */
  function sizeOption(vo) {
    return vo && vo.querySelector('.mm3-opt--size');
  }
  function goToSize(vo) {
    const size = sizeOption(vo) || vo;
    if (!size) return;
    size.scrollIntoView(scrollOpts('center'));
    size.classList.remove('mm3-attn');
    void size.offsetWidth;
    size.classList.add('mm3-attn');
    const first = size.querySelector('label[for]:not(.disabled)') || size.querySelector('label[for]');
    setTimeout(() => first && first.focus({ preventScroll: true }), reduceMotion() ? 0 : 450);
  }

  function variantData(vo) {
    try {
      return JSON.parse(vo.querySelector('script[type="application/json"]:not([data-selected-variant])').textContent);
    } catch (e) {
      return [];
    }
  }

  function syncPending(vo) {
    const sid = vo.dataset.section;
    const btn = document.getElementById(`ProductSubmitButton-${sid}`);
    if (!btn || !btn.hasAttribute('data-mm3-select-label')) return;
    const sizeOpt = sizeOption(vo);
    const pending = !!sizeOpt && !sizeOpt.querySelector('input:checked');
    const colorFs = vo.querySelector('.mm3-opt--color');
    const color = colorFs ? (Array.from(colorFs.querySelectorAll('input')).find((i) => i.checked)?.value || '') : '';

    if (pending) {
      btn.setAttribute('data-mm3-pending', '');
      btn.setAttribute('aria-disabled', 'true');
      btn.removeAttribute('disabled');
      const span = btn.querySelector('.wt-btn__label span');
      if (span) span.textContent = btn.dataset.mm3SelectLabel;
      document.getElementById(`price-${sid}`)?.classList.remove('visibility-hidden');
      // sabit çubuk: renk + o rengin görseli (varyant çözülmediği için Wonder güncellemez)
      if (color) {
        document.querySelectorAll(`#sticky-price-${sid} [data-mm3-color]`).forEach((el) => { el.textContent = color; });
        const idx = Array.from(vo.querySelectorAll('.wt-product__option')).indexOf(colorFs);
        const v = variantData(vo).find((x) => x.options[idx] === color && x.featured_media);
        const img = document.getElementById(`sticky-image-${sid}`);
        const src = v?.featured_media?.preview_image?.src;
        if (img && src) {
          const u = (w) => `${src}${src.includes('?') ? '&' : '?'}width=${w}`;
          img.srcset = `${u(80)} 80w, ${u(160)} 160w`;
          img.src = u(160);
        }
      }
    } else {
      if (btn.hasAttribute('data-mm3-pending')) {
        btn.removeAttribute('data-mm3-pending');
        if (!btn.classList.contains('loading')) btn.removeAttribute('aria-disabled');
      }
      // Wonder'ın toggleAddButton()'ı bu işaretlemede etiketi bulamıyor ('[name="add"] > span' yok, span .wt-btn__label
      // içinde) ve erken dönüyor: etiket + disabled durumu burada, varyant verisinden.
      const opts = optionsOf(vo);
      const v = variantData(vo).find((x) => x.options.every((o, i) => o === opts[i]));
      const span = btn.querySelector('.wt-btn__label span');
      const strings = window.variantStrings || {};
      let label;
      if (!v) { btn.disabled = true; label = strings.unavailable || 'Unavailable'; }
      else if (!v.available) { btn.disabled = true; label = strings.soldOut || 'Sold out'; }
      else { btn.disabled = false; label = btn.dataset.customAddLabel || strings.addToCart || 'Add to cart'; }
      if (span && span.textContent.trim() !== label) span.textContent = label;
      document.getElementById(`price-${sid}`)?.classList.remove('visibility-hidden');
    }
  }

  document.addEventListener('variantChangeEnd', (e) => {
    const vo = e.target && e.target.closest ? e.target.closest('variant-options') : null;
    if (vo) syncPending(vo);
  });

  // "Select a size" tıklaması: beden seçicisine git (product-form aria-disabled'da göndermez)
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('[data-mm3-pending]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const sid = btn.id.replace('ProductSubmitButton-', '');
      goToSize(document.querySelector(`variant-options[data-section="${sid}"]`));
    },
    true,
  );

  /* ---------- 3) beden rehberi (Pify) ---------- */
  function wireSizeGuide() {
    const links = document.querySelectorAll('[data-mm3-size-guide]');
    if (!links.length) return;
    const pify = () => document.querySelector('.wt-product__main .pify_inline_button') || document.querySelector('.pify_inline_button');
    const reveal = () => {
      if (!pify()) return false;
      links.forEach((l) => { l.hidden = false; });
      return true;
    };
    links.forEach((l) =>
      l.addEventListener('click', () => {
        const p = pify();
        if (p) p.click();
      }),
    );
    if (reveal() || !('MutationObserver' in window)) return;
    const mo = new MutationObserver(() => {
      if (reveal()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 20000);
  }

  /* ---------- 4) sabit çubuk ---------- */
  function wireSticky() {
    document.querySelectorAll('sticky-buy-button').forEach((sticky) => {
      const btn = sticky.querySelector('button');
      if (!btn || sticky.hasAttribute('data-add-to-cart')) return;
      const section = sticky.closest('[data-section-id]');
      const sid = section?.dataset.sectionId;
      sticky.addEventListener(
        'click',
        (e) => {
          if (!btn.contains(e.target)) return;
          const main = document.getElementById(`ProductSubmitButton-${sid}`);
          const vo = document.querySelector(`variant-options[data-section="${sid}"]`);
          if (!main) return;
          e.preventDefault();
          e.stopPropagation();
          if (main.hasAttribute('data-mm3-pending')) goToSize(vo);
          else if (!main.disabled) main.click();
          else main.closest('.wt-product__add-to-cart')?.scrollIntoView(scrollOpts('center'));
        },
        true,
      );
    });
  }

  /* ---------- 5) akordeon: tek açık ---------- */
  function wireAccordion() {
    document.querySelectorAll('.wt-product__main collapsible-section.wt-collapse').forEach((c) => {
      if (!c.dataset.accordionSet) {
        c.dataset.accordionSet = 'mm3-pdp';
        c.accordionSet = 'mm3-pdp';
      }
    });
  }

  /* ---------- 6) galeri hapları: erişilebilir ad ---------- */
  function wirePagerLabels() {
    document.querySelectorAll('gallery-section[data-mm3-max] [data-gallery] .swiper-pagination').forEach((pg) => {
      const apply = () => {
        const bullets = pg.querySelectorAll('.swiper-pagination-bullet');
        const n = bullets.length;
        bullets.forEach((b, i) => {
          const label = `Show image ${i + 1} of ${n}`;
          if (b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
          const on = b.classList.contains('swiper-pagination-bullet-active') ? 'true' : 'false';
          if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
          if (b.hasAttribute('aria-current')) b.removeAttribute('aria-current'); // aria-pressed ile çift duyuru olmasın
        });
      };
      apply();
      // yalnız Swiper'ın yazdığı öznitelikler izlenir (aria-pressed değil): kendi yazdığımız değişiklik döngü kurmaz
      new MutationObserver(apply).observe(pg, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-label', 'aria-current'] });
    });
  }

  function init() {
    wirePagerLabels();
    wireSizeGuide();
    wireSticky();
    wireAccordion();
    document.querySelectorAll('variant-options').forEach((vo) => {
      if (vo.closest('.wt-product__main')) syncPending(vo);
    });
    customElements.whenDefined('gallery-section').then(() => setTimeout(initialGalleryFilter, 0));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
